import { Button } from "@majitap/ui";
import { Alert } from "@majitap/ui/arc/alert/alert";
import { Dialog, DialogContent } from "@majitap/ui/arc/dialog/dialog";
import { useMutation } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { errorOf } from "../../api";
import { messageFor } from "../../error-copy";
import styles from "./confirm.module.css";

/**
 * Asks before one action, runs it, and shows the API's refusal in place. For a change that needs
 * a sentence of explanation; a one-line undoable one uses `ConfirmMorph` in the row instead.
 */
export function ConfirmDialog({
  title,
  description,
  action,
  keep = "Cancel",
  danger = false,
  run,
  onDone,
  onClose,
}: {
  title: string;
  description: ReactNode;
  action: string;
  keep?: string;
  danger?: boolean;
  run: () => Promise<unknown>;
  onDone?: () => Promise<unknown> | void;
  onClose: () => void;
}) {
  const mutation = useMutation({
    mutationFn: run,
    onSuccess: async () => {
      await onDone?.();
      onClose();
    },
  });
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent title={title}>
        <div className={styles.form}>
          <p className={styles.description}>{description}</p>
          {mutation.error ? (
            <Alert tone="danger" title="Not done">
              {messageFor(errorOf(mutation.error))}
            </Alert>
          ) : null}
          <div className={styles.footer}>
            <Button variant="secondary" onClick={onClose}>
              {keep}
            </Button>
            <Button
              variant={danger ? "danger" : "primary"}
              loading={mutation.isPending}
              onClick={() => mutation.mutate()}
            >
              {action}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
